<script>
/* eslint-disable */
import { mapGetters } from "vuex";

import kettlebells from "../../../../../static/assets/images/mattress.svg";
import mattress from "../../../../../static/assets/images/mattress.svg";
import resistanceBand from "../../../../../static/assets/images/resistance-band.svg";
import slider from "../../../../../static/assets/images/slider.svg";
import bench from "../../../../../static/assets/images/bench.svg";
import towel from "../../../../../static/assets/images/towel.svg";
import otherWeights from "../../../../../static/assets/images/other-weights.svg";
import roller from "../../../../../static/assets/images/roller.svg";
import skippingRope from "../../../../../static/assets/images/skipping-rope.svg";
import atHome from "../../../../../static/assets/images/at-home.svg";
import trx from "../../../../../static/assets/images/trx.svg";
export default {
  name: "EquipmentCategory",
  props: {
    equipment: {
      type: Object,
    },
  },
  data() {
    return {
      icons: [
        kettlebells,
        mattress,
        resistanceBand,
        slider,
        bench,
        towel,
        otherWeights,
        roller,
        atHome,
        skippingRope,
        trx
      ],
    };
  },
  computed: {
    currentEquipment() {
      return this.$store.getters[`${this.currentType}/currentEquipment`];
    },
    currentActivity() {
      return this.$store.getters[`${this.currentType}/currentActivity`];
    },
    currentType() {
      const url = this.$route.path.split("/")[1];
      if (this.$route) {
        if (url == "update-warmup" || this.$route.path == "/create-warmup") {
          return "warmups";
        } else if (
          url == "update-stretch-flow" ||
          this.$route.path == "/create-stretch-flow"
        ) {
          return "stretchflows";
        }
      }
      return "workouts";
    },
  },
  methods: {
    // Open sidebar and display the equipment details
    openSidebar: function () {
      this.$store.dispatch(`${this.currentType}/openSidebar`);
      this.$store.dispatch(`${this.currentType}/getEquipment`, this.equipment);

      this.findactiveEquipments();
    },
    findactiveEquipments: function () {
      if (
        this.currentActivity &&
        this.currentActivity.selected_equipments &&
        this.currentEquipment &&
        this.currentEquipment.equipments
      ) {
        this.currentEquipment.equipments.map((equipment) => {
          equipment.selected = false;
          equipment.selected_option = "no";
          return this.currentActivity.selected_equipments.map((workout) => {
            if (equipment.id == workout.equipment) {
              equipment.selected = true;
              equipment.selected_option = workout.selected_option;
              equipment.e_id = workout.id;
            }
            console.log(equipment);
            return equipment;
          });
        });
      }
    },
  },
};
</script>
<style lang="scss">
.equipments-content {
  .category {
    position: relative;
    min-height: 140px;
    .icon {
      width: 20px;
      position: absolute;
      right: 10px;
      top: 10px;
      display: none;
      color: #3f9698;
    }
    &.selected {
      border: 1px solid #3f9698;
      background: #effdff;

      .icon {
        display: block;
      }
    }
  }
  h4 {
    font-size: 18px;
    margin: 0;
  }
  span {
    color: #00000066;
    font-size: 13px !important;
  }
}
</style>


<template>
  <div class="col-12 col-xl-4">
    <div
      class="border rounded mb-4 p-4 cursor-pointer category"
      :class="equipment.selected.length ? 'selected' : ''"
      @click="openSidebar()"
    >
      <b-icon stacked icon="check-circle" class="icon"></b-icon>

      <img :src="icons[equipment.id - 1]" class="mb-2" />
      <h4>{{ equipment.label }}</h4>
      <span>({{ equipment.selected.length }} selected)</span>
    </div>
  </div>
</template>